
import React, { Component } from 'react';

import { Modal, ModalBody, Card, CardBody, Button, CardHeader, ModalHeader } from 'reactstrap';
import WizardModifierDialogue from '../Wizard/WizardModifierDialogue';

var constants = require('../../../../../utils/domain/constants.js');
var snoozeUtil = require('../../../../../utils/domain/snoozeUtil');
var formatter = require('../../../../../utils/formatter/formatter.js');
var stringUtil = require('../../../../../utils/string/stringUtil.js');

var modifierDialogueUtil = require('../modifierDialogueUtil.js');
const translator = require('../../../../../utils/translator/translator');


const defaultModifierItemBackColor = "#F8F8F8";
const defaultModifierItemForeColor = "#686868";
class ColumnModifierDialogue extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.selectedModifierIndex = 0;
        this.state.layout = "singleColumn";

        if (this.props.startingModifierIndex >= 0 && this.props.startingModifierIndex < this.props.modifiersViewModels.length)
            this.state.selectedModifierIndex = this.props.startingModifierIndex;

        let activeModifiersCount = 0;
        for (var index = 0; index < this.props.modifiersViewModels.length; index++)
        {
            let modifierViewModel = this.props.modifiersViewModels[index];

            if (this.props.isNewOrderFlow && modifierViewModel.underlyingModifier.hiddenInOrderFlow)
                continue;

            if (this.props.isNewOrderFlow && modifierDialogueUtil.isModifierSystemAutoSelected(modifierViewModel.underlyingModifier))
                continue;

            activeModifiersCount++;
        }

        if (activeModifiersCount <= 3)
            this.state.layout = "multiColumn";
    }

    render()
    {

        return  <Modal isOpen={true} centered animation={false} fade={false} size="lg" style={{maxWidth: '80%'}}>
                    <ModalHeader style={{display: "flex", justifyContent: "center",alignItems: "center", }}>
                        {this.props.saleItem.caption}
                    </ModalHeader>
                    <div style={{marginLeft:'10px', marginRight:'10px', marginTop:'10px', marginBottom:'20px'}}>
                        
                        <table style={{width:'100%', minHeight:'40vh'}}>
                                <tr>
                                    <td style={{width:'20%', borderRight:'1px solid #888888', verticalAlign:'bottom', background:'#696969', color:'#F8F8F8'}}>
                                            {this.renderSelections()}
                                    </td>
                                    <td style={{width:'80%', verticalAlign:'top'}}>
                                        {this.renderModifiers()}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <hr style={{marginTop:'0px', paddingTop:'0px'}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} style={{textAlign:'end'}}>
                                        <Button color="secondary" className="btn-secondary" style={{marginTop:'0px', marginRight:'10px', minWidth:'100px'}} onClick={this.props.onCancel}>
                                            {translator.getLabel("cancel")}
                                        </Button>

                                        <Button disabled={!this.isFinishAllowed()} color="success" className="btn-success" style={{marginTop:'0px', minWidth:'100px'}} onClick={()=>{this.props.onSave(this.props.modifiersViewModels);}}>
                                            {translator.getLabel("finish")}
                                        </Button>
                                    </td>
                                </tr>
                        </table>
                    </div>
                    {this.renderWizardModifierDialogue()}
                </Modal>
    }

    renderModifiers()
    {
        if (this.state.layout == "singleColumn")
            return this.renderModifiersInSingleColumnFormat();

        return this.renderModifiersInMultiColumnFormat();
    }

    renderModifiersInMultiColumnFormat()
    {
        var columns = [];
        for (var index = 0; index < this.props.modifiersViewModels.length; index++)
        {
            let modifierViewModel = this.props.modifiersViewModels[index];

            if (this.props.isNewOrderFlow && modifierViewModel.underlyingModifier.hiddenInOrderFlow)
                continue;

            if (this.props.isNewOrderFlow && modifierDialogueUtil.isModifierSystemAutoSelected(modifierViewModel.underlyingModifier))
                continue;

            var components = [];
            components.push(this.renderModifierCaption(modifierViewModel, index));

            for (var itemIndex = 0; itemIndex < modifierViewModel.items.length; itemIndex++)
                components.push(this.renderModifierItem(modifierViewModel, modifierViewModel.items[itemIndex]));

            columns.push(<td style={{borderRight:'2px solid #B0B0B0'}}><div style={{overflowY:'auto', height:'40vh'}}>{components}</div></td>)
        }

        return <table style={{width:'100%'}}>
                    <tr>
                        {columns}
                    </tr>
                </table>

    }

    renderModifiersInSingleColumnFormat()
    {
        var modifierCaptionComponents = [];

        for (var index = 0; index < this.props.modifiersViewModels.length; index++)
        {
            let modifierViewModel = this.props.modifiersViewModels[index];

            if (this.props.isNewOrderFlow && modifierViewModel.underlyingModifier.hiddenInOrderFlow)
                continue;
            
            if (this.props.isNewOrderFlow && modifierDialogueUtil.isModifierSystemAutoSelected(modifierViewModel.underlyingModifier))
                continue;
            
            modifierCaptionComponents.push(this.renderModifierCaption(modifierViewModel, index))
        }

        return <table style={{width:'100%', minHeight:'40vh'}}>
                    <tr>
                        <td style={{width:'40%', borderRight:'2px solid #B0B0B0', verticalAlign:'top'}}>
                            <div style={{overflowY:'auto', height:'40vh'}}>{modifierCaptionComponents}</div>
                        </td>
                        <td style={{verticalAlign:'top'}}>
                            <div style={{overflowY:'auto', height:'40vh'}}>
                                {this.renderModifierItems(this.props.modifiersViewModels[this.state.selectedModifierIndex])}
                            </div>
                        </td>
                    </tr>
               </table>

    }

    renderModifierCaption(modifierViewModel, index)
    {
        let backgroundColor = null;
        let color = null;
        var onClick = ()=>{};

        if (this.state.layout == "singleColumn")
        {
            backgroundColor = "#E8E8E8";
            color = "#505050";

            if (this.state.selectedModifierIndex == index)
            {
                backgroundColor = "#696969";
                color = "#F5F5F5"
            }

            onClick = ()=>
            {
                this.state.selectedModifierIndex = index;
                this.setState({});
            }
        }
        else
        {
            backgroundColor = "#696969";
            color = "#F5F5F5"
        }
        
        return  <div style={{border:'1px solid #696969', 
                             paddingLeft:'15px', paddingRight:'15px', paddingTop:'20px', paddingBottom:'20px',
                             backgroundColor:backgroundColor,
                             color:color}}
                             onClick={onClick}>
                    {modifierViewModel.underlyingModifier.caption}
                </div>
    }

    renderModifierItems(modifierViewModel)
    {
        var components = [];

        for (var index = 0; index < modifierViewModel.items.length; index++)
            components.push(this.renderModifierItem(modifierViewModel, modifierViewModel.items[index]));

        return components;
    }

    renderModifierItem(modifierViewModel, modifierItemViewModel)
    {
        if (this.isModifierMemberDisabled(modifierItemViewModel.underlyingModifierItem))
            return this.renderDisabledModifierOption(modifierItemViewModel);


        var priceLabel = "N/A";

        if (modifierItemViewModel.underlyingModifierItem.price != null)
            priceLabel = formatter.convertToCurrencyFormat(modifierItemViewModel.underlyingModifierItem.price);
        
        var borderLeftColor = null;
        var borderLeftWidth = null;

        if (modifierItemViewModel.quantity > 0)
        {
            borderLeftColor = '#606060';
            borderLeftWidth = '15px'
        }

        var backgroundColor = modifierItemViewModel.underlyingModifierItem.backgroundColor;
        var foregroundColor = modifierItemViewModel.underlyingModifierItem.foregroundColor;

        if (stringUtil.isStringNullOrEmpty(backgroundColor) || stringUtil.isStringNullOrEmpty(foregroundColor))
        {
            backgroundColor = defaultModifierItemBackColor;
            foregroundColor = defaultModifierItemForeColor;
        }

        var multipleSelectionAllowed = modifierViewModel.underlyingModifier.max > 1;
        var canSingleItemBeSelectedMultipleTimes = modifierViewModel.underlyingModifier.canSameItemBeSelectedMultipleTimes;

        var quantityControl = null;
        if (multipleSelectionAllowed && canSingleItemBeSelectedMultipleTimes)
        {
            quantityControl = <td  style={{whiteSpace: "nowrap", verticalAlign:'top'}}>
                                    <table>
                                        <tr>
                                            <td onClick={()=>{
                                                                if (modifierItemViewModel.quantity == 0)
                                                                    return;

                                                                modifierItemViewModel.quantity = modifierItemViewModel.quantity - 1;
                                                                this.populateAutoSelections(modifierItemViewModel);

                                                                this.setState({});
                                                            }}>
                                                <Card style={{padding:'0px', margin:'0px'}}>
                                                    <CardHeader style={{height:'35px', margin:'0px', textAlign:'center'}}>
                                                        <div style={{marginTop:'-15px', fontSize:'1.8em', color:'#686868'}}>-</div>
                                                    </CardHeader>
                                                </Card>
                                            </td>

                                            
                                            <td>

                                                <Card style={{padding:'0px', margin:'0px', marginLeft:'-2px'}}>
                                                    <CardHeader style={{height:'35px', margin:'0px', textAlign:'center', background:'#F8F8F8'}}>
                                                        <div style={{marginTop:'-10px', fontSize:'1.5em', color:'#686868'}}>{modifierItemViewModel.quantity}</div>
                                                    </CardHeader>
                                                </Card>
                                            </td>

                                            <td onClick={()=>{
                                                                if (!this.canAddModifierMember(modifierItemViewModel.underlyingModifierItem))
                                                                    return;
                                                                    
                                                                if (this.maximumSelectionReached(modifierViewModel))
                                                                    return;

                                                                modifierItemViewModel.quantity = modifierItemViewModel.quantity + 1;
                                                                this.populateAutoSelections(modifierItemViewModel);

                                                                this.state.wizardModifierDialogue = {};
                                                                this.state.wizardModifierDialogue.itemViewModel = modifierItemViewModel;
                                                                this.state.wizardModifierDialogue.isNewOrderFlow = this.props.isNewOrderFlow;
                                                                this.setState({});
                                                            }}>

                                                <Card style={{padding:'0px', margin:'0px', marginLeft:'-2px'}}>
                                                    <CardHeader style={{height:'35px', margin:'0px', textAlign:'center'}}>
                                                        <div style={{marginTop:'-15px', fontSize:'1.8em', color:'#686868'}}>+</div>
                                                    </CardHeader>
                                                </Card>
                                            </td>
                                            
                                            
                                        </tr>
                                    </table>
                                </td>
        }

        var selectionChangeControl = null;
        if (modifierItemViewModel.modifiersViewModels.length > 0 && modifierItemViewModel.quantity > 0)
        {
            selectionChangeControl = <td onClick={()=>
                                        {
                                            this.state.wizardModifierDialogue = {};
                                            this.state.wizardModifierDialogue.itemViewModel = modifierItemViewModel;
                                            this.state.wizardModifierDialogue.isNewOrderFlow = false;

                                            this.setState({});
                                        }}>
                                        <Card style={{padding:'0px', margin:'0px', marginRight:'10px', marginTop:'-3px'}}>
                                            <CardHeader style={{textAlign:'center', paddingLeft:'15px', paddingRight:'15px', paddingTop:'6px', paddingBottom:'6px'}}>
                                                <div style={{color:'#686868'}}>{translator.getLabel("edit")}</div>
                                            </CardHeader>
                                        </Card>
                                     </td>
        }

        return (<Card style={{marginLeft:'0px', marginRight:'0px', marginTop:'0px', marginBottom:'3px', minWidth:'20vw', 
                              background:backgroundColor, borderLeftColor:borderLeftColor, borderLeftWidth:borderLeftWidth}}>
                    <CardBody style={{padding:'10px'}}>
                        <table width="100%">
                            <tr>
                                <td style={{width:"100%", verticalAlign:'top'}} onClick={()=>
                                {

                                    if (modifierItemViewModel.quantity == 1)
                                    {
                                        modifierItemViewModel.quantity = 0;
                                    }
                                    else
                                    {
                                        if (!this.canAddModifierMember(modifierItemViewModel.underlyingModifierItem))
                                            return;

                                        if (!multipleSelectionAllowed)
                                        {
                                            modifierViewModel.items.forEach(m => m.quantity = 0);
                                            modifierItemViewModel.quantity = 1;
                                            this.populateAutoSelections(modifierItemViewModel);

                                            this.state.wizardModifierDialogue = {};
                                            this.state.wizardModifierDialogue.itemViewModel = modifierItemViewModel;
                                            this.state.wizardModifierDialogue.isNewOrderFlow = this.props.isNewOrderFlow;
                                        }
                                        else
                                        {
                                            if (this.maximumSelectionReached(modifierViewModel))
                                                return;

                                            modifierItemViewModel.quantity = 1;
                                            this.populateAutoSelections(modifierItemViewModel);

                                            this.state.wizardModifierDialogue = {};
                                            this.state.wizardModifierDialogue.itemViewModel = modifierItemViewModel;
                                            this.state.wizardModifierDialogue.isNewOrderFlow = this.props.isNewOrderFlow;
                                        }
                                    }

                                    this.setState({});
                                }}>
                                    <div className="text-muted" style={{marginTop:'3px', color:'red'}}>
                                        <strong>
                                            <div style={{color:foregroundColor}}>{modifierItemViewModel.underlyingModifierItem.caption}</div>
                                        </strong>
                                    </div>

                                    <div style={{marginTop:'3px', color:'red'}}>
                                        <small className="text-muted">
                                            <div style={{color:foregroundColor}}>{modifierItemViewModel.underlyingModifierItem.notes}</div>
                                        </small>
                                    </div>
                                    
                                    <div className="text-left text-muted" style={{marginTop:'3px', color:'red'}}>
                                        <small>
                                            <div style={{color:foregroundColor}}>{priceLabel}</div>
                                        </small>
                                    </div>
                                </td>
                                {selectionChangeControl}
                                {quantityControl}
                            </tr>
                        </table>
                    </CardBody>
                </Card>
        );
    }

    renderDisabledModifierOption(modifierItemViewModel)
    {
        var priceLabel = "N/A";

        if (modifierItemViewModel.underlyingModifierItem.price != null)
            priceLabel = formatter.convertToCurrencyFormat(modifierItemViewModel.underlyingModifierItem.price);
      
        var backgroundColor = '#808080';
        var foregroundColor = '#F8F8F8';

        var caption = modifierItemViewModel.underlyingModifierItem.caption;
        if (this.isModifierMemberSnoozed(modifierItemViewModel.underlyingModifierItem))
            caption = `${caption} - ${translator.getLabel("out_Of_stock")}`
        
        return (<Card style={{marginLeft:'5px', marginRight:'0px', marginTop:'0px', marginBottom:'3px', minWidth:'400px', 
                              background:backgroundColor}}>
                    <CardBody style={{padding:'10px'}}>
                        <table width="100%">
                            <tr>
                                <td style={{width:"100%", verticalAlign:'top'}}>
                                    <div className="text-muted" style={{marginTop:'3px', color:'red'}}>
                                        <strong>
                                            <div style={{color:foregroundColor, textDecorationLine: 'line-through'}}>{caption}</div>
                                        </strong>
                                    </div>

                                    <div style={{marginTop:'3px', color:'red'}}>
                                        <small className="text-muted">
                                            <div style={{color:foregroundColor, textDecorationLine: 'line-through'}}>{modifierItemViewModel.underlyingModifierItem.notes}</div>
                                        </small>
                                    </div>
                                    
                                    <div className="text-left text-muted" style={{marginTop:'3px', color:'red'}}>
                                        <small>
                                            <div style={{color:foregroundColor, textDecorationLine: 'line-through'}}>{priceLabel}</div>
                                        </small>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </CardBody>
                </Card>
        );
    }

    renderSelections()
    {
        var components = [];
        for (var index = 0; index < this.props.modifiersViewModels.length; index++)
        {
            let modifierViewModel = this.props.modifiersViewModels[index];

            for (var itemIndex = 0; itemIndex < modifierViewModel.items.length; itemIndex++)
            {
                let modifierItemViewModel = modifierViewModel.items[itemIndex];
                if (modifierItemViewModel.quantity > 0)
                    this.renderItemSelection(components, modifierItemViewModel, 0);
            }
        }

        if (components.length <= 0)
        {
            return <div style={{textAlign:'center', marginBottom:'20px'}}>
                        {translator.getLabel("no_selections_made")}
                    </div>
        }

        return <div style={{marginLeft:'10px', marginRight:'10px', marginBottom:'20px'}}>
                    <table style={{width:'100%'}}>
                        {components}
                    </table>
                </div>
    }

    renderItemSelection(components, modifierItemViewModel, padding)
    {
        components.push(<tr>
                            <td style={{whiteSpace:'nowrap', verticalAlign:'top'}}>
                                <div style={{marginRight:'10px'}}>
                                    {modifierItemViewModel.quantity}x
                                </div>
                            </td>
                            <td style={{width:'99%', verticalAlign:'top'}}>
                                <div style={{marginRight:'10px', paddingLeft:`${padding}px`}}>
                                    {modifierItemViewModel.underlyingModifierItem.caption}
                                </div>
                            </td>
                            <td style={{verticalAlign:'top'}}>
                                <div style={{whiteSpace:'nowrap'}}>
                                    {formatter.convertToCurrencyFormat(modifierItemViewModel.quantity * modifierItemViewModel.underlyingModifierItem.price)}
                                </div>
                            </td>
                        </tr>);

        for (var index = 0; index < modifierItemViewModel.modifiersViewModels.length; index++)
        {
            let subModifierViewModel = modifierItemViewModel.modifiersViewModels[index];
            
            for (var itemIndex = 0; itemIndex < subModifierViewModel.items.length; itemIndex++)
            {
                let subModifierItemViewModel = subModifierViewModel.items[itemIndex];
                if (subModifierItemViewModel.quantity > 0)
                    this.renderItemSelection(components, subModifierItemViewModel, padding+10);
            }
        }
    }

    isModifierMemberDisabled(modifierItem)
    {
        return this.isModifierMemberSnoozed(modifierItem);
    }

    canAddModifierMember(modifierItem)
    {
        return true;
    }

    isModifierMemberSnoozed(modifierItem)
    {
        return snoozeUtil.isItemSnoozedForSale(modifierItem, constants.SnoozeItemTypes.modifierItem, this.props.menu, this.props.sale);
    }

    maximumSelectionReached(modifierViewModel)
    {
        var quantity = 0;
        modifierViewModel.items.forEach (modifierItemViewModel =>
        {
            quantity = quantity + modifierItemViewModel.quantity;    
        });

        return quantity >= modifierViewModel.underlyingModifier.max;

    }

    isFinishAllowed()
    {
        var isSatisfied = true;
        this.props.modifiersViewModels.forEach (modifierViewModel =>
        {
            if (!modifierDialogueUtil.isModifierFullySatisfied(modifierViewModel, true))
                isSatisfied = false;
        })

        return isSatisfied;
    }

    renderWizardModifierDialogue()
    {
        
        if (this.state.wizardModifierDialogue == null)
            return;

        var modifierItemViewModel = this.state.wizardModifierDialogue.itemViewModel;
        var isNewOrderFlow = this.state.wizardModifierDialogue.isNewOrderFlow;
        
        let filteredModifiersViewModels = [];
        for (var index = 0; index < modifierItemViewModel.modifiersViewModels.length; index++)
        {
            let modifierViewModel = modifierItemViewModel.modifiersViewModels[index];

            if (isNewOrderFlow && modifierViewModel.underlyingModifier.hiddenInOrderFlow)
                continue;

            if (isNewOrderFlow && modifierDialogueUtil.isModifierSystemAutoSelected(modifierViewModel.underlyingModifier))
                continue;

            filteredModifiersViewModels.push(modifierViewModel);
        }

        if (modifierItemViewModel.quantity <= 0 || filteredModifiersViewModels.length <= 0)
        {
            this.state.wizardModifierDialogue = null;
            return;
        }
        return <WizardModifierDialogue 
                        saleItem = {modifierItemViewModel.underlyingModifierItem}
                        startingModifierIndex = {0}            
                        modifiersViewModels={filteredModifiersViewModels}
                        isNewOrderFlow={false}
                        hideCancelButton={true}
                        sale ={this.props.sale}
                        menu={this.props.menu}
                        onSave={()=>
                            {
                                this.state.wizardModifierDialogue = null;
                                this.setState({});
                            }} 
                        onCancel={()=>
                        {
                            this.state.wizardModifierDialogue = null;
                            this.setState({});
                        }}/>
    }

    populateAutoSelections(modifierItemViewModel, isRecursive)
    {
        if (modifierItemViewModel.quantity <= 0)
            return;
      
        if (isRecursive || modifierItemViewModel.quantity == 1)
        {
            for (var index = 0; index < modifierItemViewModel.modifiersViewModels.length; index++)
            {
                var modifierViewModel = modifierItemViewModel.modifiersViewModels[index];
                
                for (var iSubIndex = 0; iSubIndex < modifierViewModel.items.length; iSubIndex++)
                {
                    this.populateAutoSelection(modifierViewModel, modifierViewModel.items[iSubIndex]);
                }

            }
        }
    }

    populateAutoSelection(modifierViewModel, modifierItemViewModel)
    {
        modifierItemViewModel.quantity = 0;

        if (modifierViewModel.underlyingModifier.min == modifierViewModel.underlyingModifier.max && modifierViewModel.underlyingModifier.items.length == 1)
            modifierItemViewModel.quantity = modifierViewModel.underlyingModifier.min;
        else if (!stringUtil.isStringNullOrEmpty(modifierItemViewModel.underlyingModifierItem.autoSelectedQuantity) &&  modifierItemViewModel.underlyingModifierItem.autoSelectedQuantity > 0)
            modifierItemViewModel.quantity = modifierItemViewModel.underlyingModifierItem.autoSelectedQuantity;

        this.populateAutoSelections(modifierItemViewModel, true);
    }
}

export default ColumnModifierDialogue